<template>
  <button
    class="field__button"
    v-bind:id="getFieldId(field.name, index)"
    v-bind:type="field.type"
    v-bind:name="field.name"
    v-bind:value="field.value"
    v-bind:disabled="isSubmitting"
  >
    <span v-if="(isSubmitting && field.submitting !== '')">{{ field.submitting }}</span>
    <span v-else>{{field.value}}</span>
  </button>
</template>

<script>
// @ is an alias to /src
import field from '@/components/mixin/field';

export default {
  name: 'ButtonField',
  mixins: [field],
  props: [
    'index',
    'field',
  ],
  computed: {
    isSubmitting() {
      return this.$store.state.isSubmitting;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$field-button: $charcoal;
$field-button-hover: $orange;

// Custom styles
.field__button {
  @include nike-heading;
  font-size: 16px;
  color: $white;
  background-color: $field-button;
  transition: opacity 220ms ease;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
